import { useEffect, useState } from "react";
import "../assets/styles/views/credentials-expired.scss";
import { useOutletContext, NavLink, useLocation } from "react-router-dom";
import PasswordField from "../components/PasswordField";
import CredentialsUpdateConfirm from "../components/modal-contents/CredentialsUpdateConfirm";
import { user_credentials_update } from "../utils/endpoints";

export default function CredentialsExpired() {
  const [context, setContext] = useOutletContext();
  const [password_strength, setPasswordStrength] = useState(0);
  const [email, setEmail] = useState();
  const location = useLocation();

  useEffect(() => {
    if (location && location.state) setEmail(location.state);
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const obj = {
      email: e.target.email.value,
      currentPassword: e.target.current_password.value,
      newPassword: e.target.new_password.value,
      tenantGuid: process.env.REACT_APP_GUID,
    };

    if (obj.newPassword !== e.target.confirm_password.value)
      context.openMessage("danger", "Le due password non corrispondono.");
    else {
      let response = await context.httpRequest(
        "post",
        user_credentials_update,
        obj
      );

      if (!!response && response.result) {
        document
          .querySelector(".main-panel")
          .classList.add("remove-main-panel");
        context.openModal(
          <CredentialsUpdateConfirm context={context} />,
          false
        );
      }
    }
  };

  const handlePasswordTyping = (e) => {
    const password = e.target.value;
    let strength = 0;
    if (/[a-z]/g.test(password)) strength++;
    if (/[A-Z]/g.test(password)) strength++;
    if (/[1-9]/g.test(password)) strength++;
    if (/.{8,}/g.test(password)) strength++;

    setPasswordStrength(strength);
  };

  return (
    <section className="credentials-expired mt-md-5 w-100 main-panel p-3">
      <div className="d-flex align-items-center">
        <h1 className="m-0">Rinnovo credenziali</h1>
        <NavLink to="/faq" className="ms-auto">
          FAQ
        </NavLink>
      </div>
      <small className="mt-3 d-block">
        Aggiorna la tua password per poter accedere.
      </small>
      <form onSubmit={(e) => handleSubmit(e)}>
        {/*FIX PASSWORD MANAGER FIREFOX*/}
        <input type="password" hidden />
        {/*FIX PASSWORD MANAGER FIREFOX*/}

        <label className="d-block mt-3">EMAIL</label>
        <input
          defaultValue={email}
          name="email"
          type="email"
          className="w-100"
          required
          disabled
        />

        <label className="d-block mt-3">VECCHIA PASSWORD</label>
        <PasswordField
          name="current_password"
          required={true}
          check_format={false}
        />

        <label className="d-block mt-3">NUOVA PASSWORD</label>
        <PasswordField
          name="new_password"
          required={true}
          onChange={(e) => handlePasswordTyping(e)}
        />

        <div className="d-flex align-items-center mt-2">
          <small>Sicurezza password</small>
          <meter
            className="w-50 ms-auto"
            min="0"
            max="4"
            low="1"
            high="3"
            optimum="4"
            value={password_strength}
          ></meter>
        </div>
        <small className="mt-2 d-block">
          Minimo 8 caratteri, almeno un carattere maiuscolo, almeno un carattere
          minuscolo ed almeno un numero.
        </small>

        <label className="d-block mt-3">CONFERMA PASSWORD</label>
        <PasswordField name="confirm_password" required={true} />

        <button className="mt-3 p-3 w-100 q8-blue-button" type="submit">
          AGGIORNA CREDENZIALI
        </button>

        <span className="mt-4 text-center d-block">
          Torna alla <NavLink to="/login">Log in</NavLink>
        </span>
      </form>
    </section>
  );
}
